import {
	createStore,
	createActionsHook,
	createStateHook,
	type StoreActionApi,
} from 'react-sweet-state';

import { type ConversationAction } from '@confluence/conversation-assistant/entry-points/conversation-assistant';

export type ConfluenceRovoButtonState = {
	editorActions: ConversationAction[];
	consumptionActions: ConversationAction[];
};

const initialState: ConfluenceRovoButtonState = {
	editorActions: [],
	consumptionActions: [],
};

export const actions = {
	setEditorActions:
		(editorActions: ConversationAction[]) =>
		({ setState }: StoreActionApi<ConfluenceRovoButtonState>) => {
			setState({ editorActions });
		},
	setConsumptionActions:
		(consumptionActions: ConversationAction[]) =>
		({ setState }: StoreActionApi<ConfluenceRovoButtonState>) => {
			setState({ consumptionActions });
		},
};

export const ConfluenceRovoButtonStore = createStore({
	initialState,
	actions,
	name: 'ConfluenceRovoButtonStore',
});

export const useConfluenceRovoButtonActions = createActionsHook(ConfluenceRovoButtonStore);
export const useConfluenceRovoButtonEditorActions = createStateHook(ConfluenceRovoButtonStore, {
	selector: (state: ConfluenceRovoButtonState) => state.editorActions,
});
export const useConfluenceRovoButtonConsumptionActions = createStateHook(
	ConfluenceRovoButtonStore,
	{
		selector: (state: ConfluenceRovoButtonState) => state.consumptionActions,
	},
);
